export const OPTIN_CODES = {
  SAMSUNG_IT_PRIVACY_POLICY_AGREEMENT: "SAMSUNG_IT_PRIVACY_POLICY_AGREEMENT"
}
